function initializeCollapseMetafields() {  
  // Metafield collapse
  const collapseMetafields = document.querySelectorAll('.collapse-metafield')
  
  if(collapseMetafields.length > 0 ) {
    
    collapseMetafields.forEach( metafield => {
      const buttonText = metafield.firstChild.textContent.trim()
      const button = document.createElement('button')
      button.setAttribute('type', 'button')
      button.setAttribute('class', 'label collapsible-trigger collapsible-trigger-btn collapsible-trigger-btn--borders collapsible--auto-height')
      button.setAttribute('aria-expanded', 'false')
      button.textContent = buttonText
  
      const iconSpan = document.createElement('span')
      iconSpan.setAttribute('class', 'collapsible-trigger__icon collapsible-trigger__icon--open')
      iconSpan.setAttribute('role', 'presentation')
      iconSpan.innerHTML = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-chevron-down" viewBox="0 0 28 16"><path d="m1.57 1.59 12.76 12.77L27.1 1.59" stroke-width="2" stroke="#000" fill="none"></path></svg>'
      button.appendChild(iconSpan)
    
      const div = document.createElement('div')
      div.setAttribute('class', 'collapsible-content collapsible-content--all')

      const clonedNodeMetafield = metafield.cloneNode(true)
      clonedNodeMetafield.removeAttribute('class')
      clonedNodeMetafield.removeChild(clonedNodeMetafield.firstChild)
      const innerDiv = document.createElement('div')
      innerDiv.setAttribute('class', 'collapsible-content__inner rte')
      innerDiv.appendChild(clonedNodeMetafield)
      div.appendChild(innerDiv)
  
      metafield.innerHTML = ''
      metafield.appendChild(button)
      metafield.appendChild(div)
      metafield.classList.add('collapsibles-wrapper', 'collapsibles-wrapper--border-bottom')
  
      button.addEventListener( 'click', () => {
          const isExpanded = button.getAttribute('aria-expanded') === 'true' || false
          button.setAttribute('aria-expanded', !isExpanded)
          div.classList.toggle('is-open')
      })
    }) 
  } 

}


document.addEventListener( 'DOMContentLoaded', initializeCollapseMetafields )